import React from "react";

// shared components
import {Typography} from "../../designSystem/components/Typography";
import {DashboardCard} from "../../designSystem/components/DashboardCard";
import {InformationRow} from "./components/InformationRow";
import {InformationTable} from "./components/InformationTable";

// components
import {ApplicationApplicantInformationView} from "./components/ApplicationApplicantInformationView";
import {ApplicationInformationView} from "./components/ApplicationInformationView";
import {MNASFView} from "./components/MNASF";
import {BsrsFormResultView} from "../../features/bsrs/components/BsrsFormResultView";
import {ApplicationSurveyView} from "../ApplicationSurvey";
import {ApplicationTimestampView} from "./components/ApplicationTimestampView";
import {ApplicationAttachmentsView} from "./components/ApplicationAttachmentsView";
import {ApplicationPatientInformationView} from "./components/ApplicationPatientInformationView";
import {CategoryBanner} from "./components/CategoryBanner";

import {timestampToDate} from "../../utils/date";
import {ICase} from "../../types/Case";

interface ApplicationDetailProps {
  caseData: ICase | null;
}
export const ApplicationDetail = ({
  caseData
}: ApplicationDetailProps) => {
  if (!caseData) return null
  return (
    <div className="flex flex-col gap-6">
      <CategoryBanner
        categoryLabel={caseData.category}
        status={caseData.status}
      />

      {caseData.acceptedAt ?
        <DashboardCard>
          <Typography variant="subtitle">
            收案資訊
          </Typography>
          <InformationTable>
            <InformationRow
              title="收案機構"
              value={caseData.acceptedByOrganizationName}
            />
            <InformationRow
              title="收案時間"
              value={new Date(timestampToDate(caseData.acceptedAt)).toLocaleString()}
            />
          </InformationTable>
        </DashboardCard> : null
      }

      {caseData.assignedToOrganization ?
        <DashboardCard>
          <Typography variant="subtitle">
            派案機構
          </Typography>
          <InformationTable>
            <InformationRow
              title="派案機構"
              value={caseData.assignedToOrganizationName}
            />
            <InformationRow
              title="派案時間"
              value={new Date(timestampToDate(caseData.assignedAt)).toLocaleString()}
            />
          </InformationTable>
        </DashboardCard> : null
      }

      {caseData.report?.visitRecord &&
        <DashboardCard>
          <Typography variant="subtitle">
            結案報告
          </Typography>
          <Typography variant="body">
            {caseData.report.visitRecord}
          </Typography>
        </DashboardCard>
      }

      {/* Applicant Information */}
      <ApplicationApplicantInformationView caseData={caseData}/>

      {/* Patient Information */}
      <ApplicationPatientInformationView caseData={caseData}/>

      {/* Case Description */}
      <ApplicationInformationView caseData={caseData}/>

      {'MNASFAnswer' in caseData &&
        <MNASFView score={caseData.MNASFScore} answers={caseData.MNASFAnswer}/>
      }

      {'BSRSAnswer' in caseData &&
        <BsrsFormResultView score={caseData.BSRSScore} answers={caseData.BSRSAnswer} />
      }

      {caseData.description &&
        <DashboardCard>
          <Typography variant="subtitle">
            個案現況描述
          </Typography>
          <Typography variant="body">
            {caseData.description}
          </Typography>
        </DashboardCard>
      }

      {'surveyResponses' in caseData &&
        <ApplicationSurveyView
          surveyResponses={caseData.surveyResponses}
          feedbackDescription={caseData.feedbackDescription}
        />
      }

      {/* Timestamps */}
      <ApplicationTimestampView caseData={caseData}/>

      {/* Attachments */}
      <ApplicationAttachmentsView caseData={caseData}/>
    </div>
  )
}
